
import Method from "@/components/Method.vue";
import Welcome from "@/components/Welcome.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    Welcome,
    Method,
  },
})
export default class App extends Vue {
  readonly currentYear = new Date().getFullYear();
}
